/** Matches selectBrandCardDescriptionSx line-height × 2-line clamp */
export const BRAND_DESCRIPTION_LINE_HEIGHT_PX = 19.5
export const BRAND_DESCRIPTION_MAX_LINES = 2
export const BRAND_DESCRIPTION_COLLAPSED_MAX_HEIGHT_PX =
  BRAND_DESCRIPTION_LINE_HEIGHT_PX * BRAND_DESCRIPTION_MAX_LINES

/** Subpixel slack when line-clamp truncates (avoids false "Read more" on exact 2-line copy) */
const CLAMP_OVERFLOW_EPSILON_PX = 2

/**
 * True when a line-clamped description node still has hidden overflow.
 * Compare against the visible clamped element — not a fixed pixel height.
 */
export function isDescriptionClampedOverflowing(element: HTMLElement): boolean {
  return element.scrollHeight > element.clientHeight + CLAMP_OVERFLOW_EPSILON_PX
}
